import type IUser from '../../interfaces/IUser';

export const initialUserState: IUser = {
    email: '',
    confirmed: false,
    companyId: '',
    employeeId: -1,
};

export enum UserActionTypes {
    SET_USER = 'SET_USER',
    SET_USER_EMAIL = 'SET_USER_EMAIL',
}

interface SetUserAction {
    type: UserActionTypes.SET_USER;
    payload: IUser;
}

interface SetUserEmailAction {
    type: UserActionTypes.SET_USER_EMAIL;
    payload: string;
}

type UserAction = SetUserAction | SetUserEmailAction;

export const userReducer = (state = initialUserState, action: UserAction): IUser => {
    switch (action.type) {
        case UserActionTypes.SET_USER:
            return action.payload;
        case UserActionTypes.SET_USER_EMAIL:
            return {
                ...state,
                email: action.payload,
            };
        default:
            return state;
    }
};

export const setUser = (user: IUser): SetUserAction => ({
    type: UserActionTypes.SET_USER,
    payload: user,
});

export const setUserEmail = (email: string): SetUserEmailAction => ({
    type: UserActionTypes.SET_USER_EMAIL,
    payload: email,
});
